<template>
    <locator-container title="Poptávka materiálu - výběr dodavatele" :onPinClick="setContactId">
        <div class="locator__results">
            <div class="locator__header">
                <h2>Poptávka materiálu - výběr dodavatele</h2>
                <span class="locator__label">Hledejte dle názvu, města, čísla certifikátu nebo IČ.</span>
                <locator-search-container/>
            </div>
            <locator-contact-container :onSelect="setContactId" :selected-contact-id="contactId"/>
            <div class="clearfix"/>
            <error-state field="calculation.demand.contact.select"/>
            <div :class="{'controls__container': true, 'controls__container--fixed': contactId ? true : false}">
                <div class="pagePart-in view-mobile-nosides">
                    <div class="basicForm__row basicForm__item">
                        <button type="button" class="button view-warning" v-on:click="onContinue">
                            Pokračovat na kontaktní informace
                        </button>
                    </div>
                    <router-link v-if="selectedConstructionId && selectedProjectSlug"
                                 :to="{name: 'calculation.construction', params: {projectSlug: selectedProjectSlug, constructionId: selectedConstructionId}}"
                                 class="calculator-backLink">
                        Zpět na výpočet
                    </router-link>
                </div>
            </div>
        </div>
    </locator-container>
</template>

<script>
    import {mapGetters, mapActions} from 'vuex';
    import LocatorContainer from '../../locator/LocatorContainer';
    import LocatorSearchContainer from '../../locator/SearchContainer';
    import LocatorContactContainer from '../../locator/ContactContainer';
    import ErrorState from '../../error/ErrorState';

    export default {
        name: 'CalculationDemandContactSelect',
        components: {
            ErrorState,
            LocatorContactContainer,
            LocatorSearchContainer,
            LocatorContainer,
        },
        computed: {
            ...mapGetters('calculation', ['contactId', 'selectedProjectSlug', 'selectedConstructionId']),
            ...mapGetters('error', ['errors']),
        },
        mounted() {
            this.fetchContacts();
        },
        created() {
            this.setLocatorType('calculation');
        },
        methods: {
            ...mapActions('calculation', ['setErrors', 'setContactId']),
            ...mapActions('locator', ['setLocatorType', 'fetchContacts']),
            ...mapActions('error', ['setError', 'clearErrors']),
            onContinue() {
                this.isValidate()
                if (this.errors.length === 0) {
                    this.$router.push({name: 'calculation.demandInfomration'})
                }
            },
            isValidate() {
                this.clearErrors();
                if (null === this.contactId) {
                    this.setError({msg: 'Vyberte dodavatele', key: 'calculation.demand.contact.select'});
                }
            },
        }
    }
</script>



// WEBPACK FOOTER //
// src/components/calculation/demand/DemandContactSelect.vue